import { createEmpirePlugin } from "@empireapi/vue";
import { createApp } from "vue";
import type { Plugin } from "vue";

import App from "./App.vue";
import { empire } from "./empire";
import { router } from "./router";
import "./styles.css";

createApp(App)
  .use(createEmpirePlugin(empire) as unknown as Plugin)
  .use(router)
  .mount("#app");
